import React, { useState } from "react";

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    comment: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    console.log("Form submitted"); // Debug log
    e.preventDefault();

    // Create a more readable email body with proper line breaks
    const emailBody = [
      `Name: ${formData.name}`,
      `Phone: ${formData.phone}`,
      `Email: ${formData.email}`,
      `Service Interest: ${formData.service}`,
      `Comment: ${formData.comment}`,
    ].join("%0D%0A");

    console.log("Email body:", emailBody);

    try {
      // Create and encode the mailto link with proper encoding
      const subject = encodeURIComponent(
        `New Project Inquiry from ${formData.name}`
      );
      const body = encodeURIComponent(emailBody);
      const mailtoLink = `mailto:farm2foodglobal@gmail.com?subject=${subject}&body=${body}`;

      console.log("Mailto link:", mailtoLink);

      // Open email client
      window.location.href = mailtoLink;

      // Clear form after sending
      setFormData({
        name: "",
        phone: "",
        email: "",
        service: "",
        comment: "",
      });
    } catch (error) {
      console.error("Error sending email:", error);
      alert("There was an error opening your email client. Please try again.");
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            Tell Us About Your Project
          </h2>
        </div>

        {/* Contact Form */}
        <div className="max-w-5xl mx-auto">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8"
            method="post"
          >
            {/* Left Column - Input Fields */}
            <div className="space-y-6">
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-orange-500"
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Your Phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-orange-500"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-orange-500"
                />
              </div>
              <div>
                <input
                  type="text"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  placeholder="Are you interested in a specific service?"
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-orange-500"
                />
              </div>
              <div>
                <label className="block w-full px-4 py-3 border border-gray-300 rounded cursor-pointer hover:bg-gray-50">
                  <input type="file" className="hidden" />
                  <span className="text-gray-500">Choose file</span>
                  <span className="text-gray-400 ml-2">No file chosen</span>
                </label>
              </div>
            </div>

            {/* Right Column - Comment Box */}
            <div>
              <textarea
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                placeholder="Your Comment"
                required
                rows={11}
                className="w-full px-4 py-3 border border-gray-300 rounded resize-none focus:outline-none focus:border-orange-500"
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="lg:col-span-2 flex justify-end">
              <button
                type="submit"
                onClick={handleSubmit}
                className="bg-orange-500 text-white px-8 py-3 rounded hover:bg-orange-600 transition-colors"
              >
                SEND MESSAGE
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
